<template>
  <ArtisanGrid ref="hospital" metaKey="BasisHospitalInfo"> </ArtisanGrid>
</template>

<script>
export default {};
</script>

<style>
</style>